import { SET_BADGES_METADATA } from 'constants/reduxActions';
import { AppAction } from 'types/app';
import { BadgesState } from 'types/badges';

const initialState = {
  metadata: []
};

export default function badges(state: Readonly<BadgesState> = initialState, action: AppAction): BadgesState {
  switch (action.type) {
    case SET_BADGES_METADATA:
      const { metadata } = action;
      return {
        ...state,
        metadata
      };
    default:
      return state;
  }
}
